import "./DateWithIndicator.css";

import { CircleFilledIcon } from "../../../assets";
import { convertDateToStringDDMMYYYY, getDeadlineColourClass } from "../../../utils";

type DateWithIndicatorFormat = "short" | "long";
type DateWithIndicatorVariant = "default" | "reverse";
type DateWithIndicatorJustify = "default" | "between";
type DateWithIndicatorAlign = "center" | "end";
type DateWithIndicatorFont = "body3Light";

interface DateWithIndicatorProps {
  date?: Date;
  format?: DateWithIndicatorFormat;
  variant?: DateWithIndicatorVariant;
  justify?: DateWithIndicatorJustify;
  isMaxHeight?: boolean;
  align?: DateWithIndicatorAlign;
  font?: DateWithIndicatorFont;
  fontColour?: string;
}

export const DateWithIndicator = ({
  date,
  format = "short",
  variant = "default",
  justify = "default",
  isMaxHeight = true,
  align = "center",
  font,
  fontColour,
}: DateWithIndicatorProps): JSX.Element | undefined => {
  if (date === undefined) return undefined;

  const colourClass = getDeadlineColourClass(date);

  const formatFunction = {
    short: convertDateToStringDDMMYYYY,
    long: (value: Date) => value.toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" }),
  };

  return (
    <div
      className={`DateWithIndicatorContainer ${colourClass} ${variant} ${justify} ${!isMaxHeight ? "NoMaxHeight" : ""} ${align}`}
    >
      <CircleFilledIcon />
      <p className={font} style={{ color: fontColour }}>
        {formatFunction[format](date)}
      </p>
    </div>
  );
};
